// import Cookies from 'js-cookie'

// const userRole = Cookies.get('role')
// console.log('userRole', userRole)

// let unAuthenticatedEntryPath = '/sign-in' // Default path

// if (userRole) {
//     switch (userRole) {
//         case 'assessor':
//             unAuthenticatedEntryPath = '/auditor-login'
//             break
//         case 'School':
//             unAuthenticatedEntryPath = '/school-login'
//             break
//         case 'qc':
//             unAuthenticatedEntryPath = '/qc-login'
//             break
//         case 'admin':
//         case 'LeadA':
//             unAuthenticatedEntryPath = '/sign-in'
//             break
//         default:
//             unAuthenticatedEntryPath = '/sign-in'
//             break
//     }
// }

// const appConfig = {
//     apiPrefix: process.env.REACT_APP_API_BASE || '/api',
//     authenticatedEntryPath: '/dashboard',
//     unAuthenticatedEntryPath: unAuthenticatedEntryPath,
//     tourPath: '/app/account/kyc-form',
//     locale: 'en',
//     enableMock: false,
// }

// export default appConfig


import Cookies from 'js-cookie';

const getRoleBasedPath = (userRole) => {
    const rolePaths = {
   'Auditors': '/auditor-login',
      'Company': '/company-login',
        'qc': '/qc-login',
        'admin': '/sign-in',
        'LeadA': '/sign-in'
    };

    return rolePaths[userRole] || '/sign-in';
};

const getUserRole = () => {
    const userRole = Cookies.get('role');
    return userRole || null;
};

const appConfig = {
    apiPrefix: process.env.REACT_APP_API_BASE || '/api',
    authenticatedEntryPath: '/dashboard',
    unAuthenticatedEntryPath: getRoleBasedPath(getUserRole()),
    tourPath: '/app/account/kyc-form',
    locale: 'en',
    enableMock: false,
};

export default appConfig;